import { inject, injectable } from "inversify";
import { BaseLoginModel } from "../../models/auth/BaseLoginModel";
import { ActionStateEnum } from "../../models/enums/operStateEnum";
import { DiTokens } from "../diTokens";
import IAlertService from "../alert/IAlertService";
import IErrorService from "../error/IErrorService";
import BaseAuthService from "./BaseAuthService";
import ISessionService from "./ISessionService";

@injectable()
/**Сервис авторизации клиента (по логину и паролю)*/
export default class AuthService extends BaseAuthService {
  constructor(
    @inject(DiTokens.AlertService) private alertService: IAlertService,
    @inject(DiTokens.ErrorService) private errorService: IErrorService,
    @inject(DiTokens.SessionService) sessionService: ISessionService
  ) { super(sessionService); }

  public async init(params: any): Promise<BaseLoginModel> {
    let model: BaseLoginModel = new BaseLoginModel();
    try {
      model = await super.init(params);

      if (model.ActionStateText)
        this.alertService.success(
          model.ActionStateText, false
        );
    }
    catch (e) {
      await this.errorService.errorHandler(e, true, false, "")
    }
    return model;
  }

  /**
   * Вход
   * @param loginModel Модель авторизации
   * @returns Модель авторизации
   */
  public async login(loginModel: BaseLoginModel): Promise<BaseLoginModel> {
    try {
      loginModel = await super.login(loginModel)
      if (!loginModel.IsSuccess) {
        const autoHide = !loginModel._isChangePassword;
        await this.alertService.show(loginModel.ActionStateText, loginModel.MsgType, autoHide);
      }
    } catch (e) {
      loginModel.ActionStateText = e.message;
      loginModel._actionState = ActionStateEnum.Error;
      await this.errorService.errorHandler(e, false, false, "");
    }
    return loginModel;
  }
}
